import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";

// সব পেজ এবং কম্পোনেন্ট ইমপোর্ট
import Layout from "./Layout";
import Home from "./Home";
import Login from "./Login";
import Stock from "./Stock";
import Purchase from "./Purchase";
import RecycleBin from "./RecycleBin";
import Reports from "./Reports";
import Settings from "./Settings";
import Sales from "./Sales";
import Contacts from "./Contacts";
import SareeSetup from "./SareeSetup";
import Returns from "./Returns";
import Accounts from "./Accounts";
import ImportData from "./ImportData";
import Due from "./Due";
import WebsiteOrders from "./WebsiteOrders";
import Payroll from "./Payroll";
import Courier from "./Courier";
import HR from "./HR";
import MyProfile from "./MyProfile";
import { RoleProvider } from "./RoleContext";
import RequireFullAccess from "./RequireFullAccess";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // App-wide behaviour for every <input type="number"> (amounts, quantities, prices).
  // Done here rather than per-field because there are ~35 of them across 14 pages.
  useEffect(() => {
    const isNumberInput = (el) => el && el.tagName === 'INPUT' && el.type === 'number';

    // Scrolling the page with the cursor over a focused number box silently changed
    // the amount -- Sohan lost a Paid value to this, and later saw a COD field drift
    // to -2 from a single fast scroll. preventDefault() is what actually stops it:
    // it cancels the browser's built-in +/-1 step for THIS wheel event, every time,
    // so a fast flick that fires several wheel events in a burst can't sneak any of
    // them through. blur() alone was one tick too late for a burst like that --
    // focus only moves after the first event's default already applied, so the
    // *next* one or two events in the same burst could still land on the input
    // before the blur took effect. Keeping blur() too so a second scroll while
    // still hovering just scrolls the page instead of trying again.
    const onWheel = (e) => {
      if (isNumberInput(document.activeElement) && document.activeElement === e.target) {
        e.preventDefault();
        document.activeElement.blur();
      }
    };

    // Click into an amount box and its contents are selected, so the first keystroke
    // replaces what's there -- typing 45 over a 0 gives 45, never 045. Selecting
    // rather than blanking the field survives the handlers that coerce '' back to 0.
    const onFocusIn = (e) => {
      if (isNumberInput(e.target)) setTimeout(() => e.target.select(), 0);
    };

    // passive: false is required for preventDefault() above to actually do anything --
    // a passive listener tells the browser "I will never call preventDefault", so with
    // passive: true the call above would silently do nothing (some browsers warn about
    // this in the console) and the value would still drift.
    document.addEventListener('wheel', onWheel, { passive: false });
    document.addEventListener('focusin', onFocusIn);
    return () => {
      document.removeEventListener('wheel', onWheel);
      document.removeEventListener('focusin', onFocusIn);
    };
  }, []);

  if (loading) return (
    <div style={{display:'flex', height:'100vh', justifyContent:'center', alignItems:'center', background:'#f4f7fe', flexDirection: 'column'}}>
      <h1 style={{color:'#4a00e0', fontFamily: 'sans-serif', margin: 0}}>Kizuna Inventory</h1>
      <p style={{color: '#888'}}>System loading, please wait...</p>
    </div>
  );

  return (
    <Router>
      {!user ? (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      ) : (
        <RoleProvider key={user.uid}>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sales" element={<Sales />} />
              <Route path="/purchase" element={<Purchase />} />
              <Route path="/stock" element={<Stock />} />
              <Route path="/saree-setup" element={<SareeSetup />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/recycle-bin" element={<RecycleBin />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/accounts" element={<Accounts />} />
              <Route path="/due" element={<Due />} />
              <Route path="/import" element={<ImportData />} /> {/* path ঠিক করা হলো */}
              <Route path="/website-orders" element={<WebsiteOrders />} />
              <Route path="/payroll" element={<RequireFullAccess><Payroll /></RequireFullAccess>} />
              <Route path="/hr" element={<RequireFullAccess><HR /></RequireFullAccess>} />
              <Route path="/my-profile" element={<MyProfile />} />
              <Route path="/courier" element={<Courier />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </RoleProvider>
      )}
    </Router>
  );
}

export default App;